export default __webpack_public_path__ + "assets/community-two-one-small.724041ae6efbb9d11753d8748aff7713.png";